import {FC} from 'react';
import MyDrawer from "../../components/header/MyDrawer";
import MyAppBar from "../../components/header/MyAppBar";

const Header: FC<{}> = ({}) => {
    return (
        <>
            <MyAppBar/>
            <MyDrawer/>
        </>
    )
};

export default Header;
